// Fluent's modal dialogs hide the rest of the page from assistive technology while they are open, by
// setting aria-hidden on the app root. When a dialog unmounts as the screen changes underneath it
// (a status change reloads the editor, then someone navigates away), that marker is sometimes left
// behind, and the whole app disappears for screen readers until a reload. The e2e suite caught it on
// 2026-10-10. This clears the marker whenever no dialog is open.

export function releaseStaleModalHiding(root: HTMLElement) {
  const dialogOpen = () => document.querySelector('[role="dialog"], [role="alertdialog"]') !== null;
  let timer: number | undefined;
  const check = () => {
    window.clearTimeout(timer);
    // Give the dialog's own cleanup its turn first.
    timer = window.setTimeout(() => {
      if (root.getAttribute("aria-hidden") === "true" && !dialogOpen()) root.removeAttribute("aria-hidden");
    }, 100);
  };
  new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
  new MutationObserver(check).observe(root, { attributes: true, attributeFilter: ["aria-hidden"] });
  window.addEventListener("hashchange", check);
}
